import DOMPurify from 'dompurify';

const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: ['h1', 'h2', 'h3', 'p', 'ul', 'li', 'hr', 'a', 'strong', 'em'],
  ALLOWED_ATTR: ['class', 'href', 'target', 'rel'],
};

export function sanitizeLegalHtml(content: string): string {
  return DOMPurify.sanitize(content, SANITIZE_OPTIONS);
}

interface LegalDocumentContentProps {
  content: string;
  className?: string;
}

export default function LegalDocumentContent({ content, className }: LegalDocumentContentProps) {
  const sanitizedContent = sanitizeLegalHtml(content);

  return (
    <div
      className={className ?? 'legal-document-content prose prose-lg prose-slate max-w-none dark:prose-invert'}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
}
